import type { ExternalOperatorShippingDetail } from '../../services/externalOperatorShippings.endpoints';

const DRAFT_KEY = 'external_operator_amendments_draft';

export type ExternalOperatorAmendmentDraft = Record<string, unknown>;

const read = (): ExternalOperatorAmendmentDraft => {
  try { return JSON.parse(localStorage.getItem(DRAFT_KEY) ?? 'null') ?? {}; }
  catch { return {}; }
};

const write = (data: ExternalOperatorAmendmentDraft) => {
  try { localStorage.setItem(DRAFT_KEY, JSON.stringify(data)); }
  catch {}
};

export const useExternalOperatorAmendmentStorage = () => {
  const draft = read();

  const updateDraft = (patch: ExternalOperatorAmendmentDraft) => {
    write({ ...read(), ...patch });
  };

  const clearDraft = () => {
    localStorage.removeItem(DRAFT_KEY);
  };

  const setShipping = (
    shippingNumber: string,
    shipping: ExternalOperatorShippingDetail | null
  ) => {
    if (!shipping) {
      clearDraft();
      return;
    }
    const current = read();
    const isNewShipping = String(current.shippingNumber) !== String(shippingNumber);
    write(
      isNewShipping
        ? { shippingNumber, shipping }
        : { ...current, shippingNumber, shipping }
    );
  };

  return { draft, updateDraft, clearDraft, setShipping };
};
